import { useAppStore } from '@/stores/app'

export const isAuthenticated = (): boolean => {
    const appStore = useAppStore()
    return appStore.isLoggedIn()
}
